<template>
    <div>
        <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between" v-for="(item, idx) in lista" :key="idx">
                <a href="#" @click.prevent="selecionar(item.model)" class="card-link">
                    <span>{{ item.model ? item.model.search : '?' }}</span>
                </a>

                <a href="#" @click="favoritar(item)" class="text-warning">
                    <i class="fas fa-star"></i>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return { 
            lista: null, 
            model_type: null, 
        }
    },

    methods: { 
        selecionar (item) { 
            this.$emit('selecionar', item);
        },

        favoritar (item) { 
            let model = {
                model_type: this.model_type, 
                model_id: item.model_id,
            };

            this.$util.loadItem(this, { 
                service: 'favoritos',
                func: 'favoritar',
                parms: model, 
            })
            .then(() => {
                this.carregar(this.model_type, true);
            });

        },

        carregar(model_type, refresh = false) { 

            if (!refresh && this.lista) {
                return;
            }

            this.model_type = model_type;

            this.$util.loadItem(this, { 
                service: 'favoritos',
                func: 'lista', 
                parms: { 
                    type: model_type,
                }
            })
            .then(res => { 
                this.lista = res.lista;
            });
        }
    }
}
</script>
